import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs';
import { errorHandl } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url.utils';

@Injectable({
  providedIn: 'root'
})
export class PlacetypesService {

  constructor(private http: HttpClient) { }
  
    savePlaceType(id: any, payload: any) {
      if (id) {
        return this.http.patch(urls.API_URL + urls.PLACE_TYPES + `/${id}`, payload)
          .pipe(catchError(errorHandl));
      }
      return this.http.post(urls.API_URL + urls.PLACE_TYPES, payload)
        .pipe(catchError(errorHandl));
    }
  
    getPlaceType(queryParams?: any) {
      const params = new HttpParams({ fromObject: queryParams });
      return this.http.get(urls.API_URL + urls.PLACE_TYPES, { params })
        .pipe(catchError(errorHandl));
    }
    getPickers(queryParams?: any) {
      const params = new HttpParams({ fromObject: queryParams });
      return this.http.get(urls.API_URL + urls.PLACE_TYPES + urls.PICKER, { params })
        .pipe(catchError(errorHandl));
    }
  
    getPlaceTypeById(id: any) {
      return this.http.get(urls.API_URL + urls.PLACE_TYPES + `/${id}`)
        .pipe(catchError(errorHandl));
    }
}
